import React from "react";
import SelectStepTemplate from "../../../template/SelectStepTemplate";
import useGetMateriais, {
  buildOutrosTecidos,
} from "../../../template/UseGetMateriais";
import TipoDivergenciasInfoKey from "../../../TipoDivergenciasInfoKey.";
import { TipoDivergenciaComponent } from "../../../TiposDeDivergencias";
import ReacaoTecidoPosCorteLarguraStep from "./ReacaoTecidoPosCorteLarguraStep";

const ReacaoTecidoPosCorte: TipoDivergenciaComponent = ({
  onBack,
  onSetStep,
}) => {
  const { loading, materiais } = useGetMateriais(
    TipoDivergenciasInfoKey.TECIDO
  );
  const newMateriais = [...materiais, buildOutrosTecidos()];

  const stepNumber = "2";
  const stepSubTitle =
    "Selecione quais as partes cortadas estão diferentes da modelagem.";
  const stepTitle = "Qual das partes cortadas que estão diferentes da modelagem?";
  return (
    <SelectStepTemplate
      data={newMateriais}
      loading={loading}
      nextStepComponent={
        ReacaoTecidoPosCorteLarguraStep as TipoDivergenciaComponent
      }
      onBack={onBack}
      onSetStep={onSetStep}
      payloadKey="tecidos"
      stepNumber={stepNumber}
      stepSubTitle={stepSubTitle}
      stepTitle={stepTitle}
    />
  );
};

export default ReacaoTecidoPosCorte;
